var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user_can_view_registration_dashboard)?_c('PoliticalParties'):_vm._e(),(_vm.user_can_view_staff_dashboard)?_c('StaffDashboard'):_vm._e(),(_vm.user_can_view_party_dashboard)?_c('PartyDashboardLinks'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }